import en from '@/locales/en'
import it from '@/locales/it'
import de from '@/locales/de'

const state = {
  currentLanguage: localStorage.getItem('language') || 'en',
  translations: {
    en,
    it,
    de
  }
}

const mutations = {
  SET_LANGUAGE(state, language) {
    state.currentLanguage = language
    localStorage.setItem('language', language)
  }
}

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  }
}

const getters = {
  currentLanguage: state => state.currentLanguage,
  translations: state => state.translations[state.currentLanguage]
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 